/** biome-ignore-all lint/complexity/noStaticOnlyClass: Runtime API client owner, static methods are sufficient. */
import type { AxiosError } from 'axios';
import { type ApiClientStateSnapshot, apiClient } from '../../ApiClient';
import type { ApiClientConfig } from '../../types';

export type ApiRuntimeStateSnapshot = ApiClientStateSnapshot;

export class ApiRuntimeService {
	static init(config: ApiClientConfig): void {
		apiClient.init(config);
	}

	static captureState(): ApiRuntimeStateSnapshot {
		return apiClient.captureState();
	}

	static restoreState(state: ApiRuntimeStateSnapshot): void {
		apiClient.restoreState(state);
	}

	static isApiError(error: unknown): error is AxiosError {
		return apiClient.isApiError(error);
	}

	static getErrorStatus(error: unknown): number | undefined {
		return ApiRuntimeService.isApiError(error)
			? error.response?.status
			: undefined;
	}

	static getErrorReason(error: unknown): string | undefined {
		if (!ApiRuntimeService.isApiError(error)) {
			return undefined;
		}

		const data = error.response?.data;

		if (typeof data !== 'object' || data === null || !('reason' in data)) {
			return undefined;
		}

		return typeof data.reason === 'string' ? data.reason : undefined;
	}
}
